import { render, staticRenderFns } from "./StateProgramReferral.vue?vue&type=template&id=f0700d0c&scoped=true&"
import script from "./StateProgramReferral.vue?vue&type=script&lang=js&"
export * from "./StateProgramReferral.vue?vue&type=script&lang=js&"
import style0 from "./StateProgramReferral.vue?vue&type=style&index=0&id=f0700d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0700d0c",
  null
  
)

export default component.exports